import type { HeadingProps } from './heading.types'

import { vui } from '../core'
import Heading from './heading'

export const H1 = vui<'h1', HeadingProps>((props, ref) => <Heading ref={ref} size="2xl" {...props} />)
export const H2 = vui<'h2', HeadingProps>((props, ref) => <Heading ref={ref} size="xl" {...props} />)
export const H3 = vui<'h3', HeadingProps>((props, ref) => <Heading ref={ref} size="lg" {...props} />)
export const H4 = vui<'h4', HeadingProps>((props, ref) => <Heading ref={ref} size="md" {...props} />)
export const H5 = vui<'h5', HeadingProps>((props, ref) => <Heading ref={ref} size="sm" {...props} />)
export const H6 = vui<'h6', HeadingProps>((props, ref) => <Heading ref={ref} size="xs" {...props} />)
